import topicsAPI from '../../../api/topics'
import clientAPI from '../../../api/client'
import { reorder } from '../../../helpers'

export default {
  async indexNoPaginate({commit, rootState}) {
    const tenantID = rootState.tenants.current.id
    const componentID = rootState.components.current.id
    const resp = await topicsAPI.index({tenantID, componentID, short: true})
    const index = resp.data.data

    commit('setComplete', {index})
  },

  async index({commit, state, rootState}, view) {
    const isFavorites = view === state._favoritesView
    const tenantID = rootState.tenants.current.id
    const meta = state.views[view].meta
    const params = {tenantID, paginate: meta.paginate}

    if (typeof(meta.active) !== 'undefined' && meta.active !== null) {
      params.active = meta.active
    }
    if (typeof(meta.archived) !== 'undefined' && meta.archived !== null) {
      params.archived = meta.archived
    }
    if (typeof(meta.order) !== 'undefined' && meta.order !== null) {
      params.order = meta.order
    }
    if (typeof(meta.desc) !== 'undefined' && meta.desc !== null) {
      params.desc = meta.desc
    }

    // don't set page if search is set
    if (typeof(meta.search) !== 'undefined' && meta.search !== null) {
      params.search = meta.search
    } else if (typeof(meta.current_page) !== 'undefined' && meta.current_page !== null) {
      params.page = meta.current_page
    }

    if (!isFavorites) {
      params.componentID = rootState.components.current.id
    }

    commit('setFetchingForView', {view, value: true})

    let resp
    if (isFavorites) {
      resp = await clientAPI.favoriteTopics(params)
    } else {
      resp = await topicsAPI.index(params)
    }
    commit('setView', {view, index: resp.data.data, meta: resp.data.meta})
    commit('setFetchingForView', {view, value: false})
  },

  async show({commit, rootState}, {id}) {
    const tenantID = rootState.tenants.current.id
    const componentID = rootState.components.current.id
    const resp = await topicsAPI.show({tenantID, componentID, topicID: id})
    const topic = resp.data.data
    commit('setCurrent', topic)
  },

  async store({commit, state, rootState, dispatch}) {
    const tenantID = rootState.tenants.current.id
    const componentID = rootState.components.current.id

    const data = {
      name: state.forms.store.fields.name,
      description: state.forms.store.fields.description
    }

    commit('forms/store/resetErrors')
    commit('forms/store/resetSuccess')
    commit('forms/store/setSaving', true)

    let resp, newTopic
    let success = true

    try {
      // store the topic
      resp = await topicsAPI.store({tenantID, componentID, data})
      newTopic = resp.data.data

    } catch (err) {
      success = false

      if (err.response) {
        if (err.response.status === 422) {
          const errors = err.response.data.errors
          commit('forms/store/setErrors', errors)
        }
      }
    }

    commit('forms/store/setSaving', false)
    commit('forms/store/setSuccess', success)

    if (success) {
      commit('setCurrent', newTopic)
      dispatch('index', state._defaultView)
    }
  },

  async update({commit, state, rootState, dispatch}, {topicID}) {
    const tenantID = rootState.tenants.current.id
    const componentID = rootState.components.current.id

    const data = {}

    if (state.forms.update.fields.active !== null) {
      data.is_active = state.forms.update.fields.active
    }

    if (state.forms.update.fields.name) {
      data.name = state.forms.update.fields.name
    }

    if (state.forms.update.fields.description) {
      data.description = state.forms.update.fields.description
    }

    commit('forms/update/resetErrors')
    commit('forms/update/resetSuccess')
    commit('forms/update/setSaving', true)

    let resp, updatedTopic
    let success = true

    try {
      // update the topic
      resp = await topicsAPI.update({tenantID, componentID, topicID, data})
      updatedTopic = resp.data.data

    } catch (err) {
      success = false

      if (err.response) {
        if (err.response.status === 422) {
          const errors = err.response.data.errors
          commit('forms/update/setErrors', errors)
        }
      }
    }

    commit('forms/update/setSuccess', success)
    commit('forms/update/setSaving', false)

    if (success) {
      commit('upsert', {view: state._defaultView, entity: updatedTopic})
      commit('setCurrent', updatedTopic)
      dispatch('index', state._defaultView)
    }
  },

  async restore({commit, state, rootState, dispatch}, id) {
    const tenantID = rootState.tenants.current.id
    const componentID = rootState.components.current.id
    const data = { 'is_deleted': false, 'is_active': true }

    commit('setFetchingForView', {view: state._defaultView, value: true})
    commit('setFetchingForView', {view: state._archivedView, value: true})
    await topicsAPI.update({tenantID, componentID, topicID: id, data})
    dispatch('index', state._defaultView)
    dispatch('index', state._archivedView)
  },

  async reorder({commit, state, rootState, dispatch}, {topicID, direction}) {
    const tenantID = rootState.tenants.current.id
    const componentID = rootState.components.current.id

    let topics = state.complete.ids.map((id) => state.complete.index[id])
    topics = reorder({elements: topics, id: topicID, direction})

    // update the store
    commit('setComplete', {index: topics})

    topics.map((element) => {
      return {
        id: element.id,
        order: element.order
      }
    })

    const data = { topics }
    commit('setFetchingForView', {view: state._defaultView, value: true})
    await topicsAPI.bulkUpdate({tenantID, componentID, data})
    dispatch('index', state._defaultView)
  },

  async archive({commit, state, rootState, dispatch}, id) {
    const tenantID = rootState.tenants.current.id
    const componentID = rootState.components.current.id

    commit('setFetchingForView', {view: state._defaultView, value: true})
    commit('setFetchingForView', {view: state._archivedView, value: true})
    await topicsAPI.destroy({tenantID, componentID, topicID: id})
    dispatch('index', state._defaultView)
    dispatch('index', state._archivedView)
  },

  async toggleFavorite({commit, state, rootState, dispatch}, {view, fetchIndex, isFavorite, componentID, topicID}) {
    const tenantID = rootState.tenants.current.id

    if (fetchIndex && view) {
      commit('setFetchingForView', {view, value: true})

      if (isFavorite) {
        await topicsAPI.removeFavorite({tenantID, componentID, topicID})
      } else {
        await topicsAPI.addFavorite({tenantID, componentID, topicID})
      }

      dispatch('index', view)

    } else {
      if (isFavorite) {
        topicsAPI.removeFavorite({tenantID, componentID, topicID})
      } else {
        topicsAPI.addFavorite({tenantID, componentID, topicID})
      }
    }
  },

  async copy({commit, state, rootState, dispatch}, id) {
    const tenantID = rootState.tenants.current.id
    const componentID = rootState.components.current.id

    commit('setFetchingForView', {view: state._defaultView, value: true})
    await topicsAPI.copy({tenantID, componentID, topicID: id})
    dispatch('index', state._defaultView)
  },

  async move({commit, state, rootState, dispatch}, {srcID, destID}) {
    const tenantID = rootState.tenants.current.id
    const componentID = rootState.components.current.id
    const data = { 'component_id': destID }
    commit('setFetchingForView', {view: state._defaultView, value: true})
    await topicsAPI.move({tenantID, componentID, topicID: srcID, data})
    dispatch('index', state._defaultView)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/topics/actions.js